/** @jsx jsx */

import { Icon } from '@zapier/zinnia-icons';
import { jsx } from '@emotion/core';

import { Button } from '@zapier/design-system';

type Props = {
  onClick: () => void;
};

const VersioningHelpButton = ({ onClick }: Props) => {
  return (
    <Button iconPosition="start" onPress={onClick} variant="secondary">
      <Icon name="navHelpFill" />
      What is versioning?
    </Button>
  );
};

export default VersioningHelpButton;
